import React from 'react';
import {AuthModalState} from '../../AuthModal';
export type AuthModalContext = SetState<AuthModalState>;

const context = React.createContext<AuthModalContext>(() => {});
context.displayName = 'AuthModalContext';
export default context;
